export default "__VITE_ASSET__Dn4OU8yi__"